import { lazy } from "react";
import type { RouteObject } from "react-router";

const ChatIndex = lazy(() => import("./pages/page"));
const Inbox = lazy(() => import("./pages/inbox/page"));
const Settings = lazy(() => import("./pages/settings/page"));

export const chatRoutes: RouteObject[] = [
  { index: true, Component: ChatIndex },
  { path: "inbox", Component: Inbox },
  { path: "settings", Component: Settings },
];
